import React from "react";

const FormattedDate = ({ timestamp, fallback = "-" }) => {
  if (!timestamp) return fallback;

  const date = new Date(timestamp);
  const formatted = date.toLocaleString("en-IN", {
    weekday: "long",
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true, // Ensures AM/PM is shown correctly
  });

  return <span>{formatted}</span>;
};

export default FormattedDate;
